/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommerceCapabilitySpec { 
    /**
     * Enable/ Disable To Suppress Enforcement Framework V2
     */
    suppress_enforcement?: boolean;
    /**
     * Enable/ Disable Org Enforcement Email Notification
     */
    enable_enforcement_email_notification?: boolean;
    /**
     * Enable/ Disable Org Usage Overage Enforcement
     */
    allow_overage?: boolean;
    /**
     * Enable/ Disable Org Usage Overage Email Notification
     */
    enable_overage_email_notification?: boolean;
    /**
     * Enable/ Disable Subscription Expiring Email Notification
     */
    enable_subscription_expiring_email_notification?: boolean;
}

